<div class="relative w-full group">
  @if (label()) {
    <label
      [for]="label()"
      class="absolute text-xs -top-2 left-3 z-10 bg-white px-1 rounded-md transition duration-300 font-medium text-neutral-700">
      {{ label() }}
    </label>
  }
  <textarea
    [id]="label()"
    [placeholder]="placeholder()"
    [readonly]="readonlyInput()"
    [disabled]="disabled()"
    [class]="textareaClasses"
    [value]="value"
    (input)="onInput($event)"
    (blur)="onTouched()"
    rows="4"></textarea>
</div>
